export default "__VITE_ASSET__Ik37Q3RA__"